import InputText, { InputTextProps } from '../input/InputText';
import { useZodFormFieldSingle } from '~/components/zod/ZodForm';
import { useEffect } from 'react';

export default function ZodFieldInput({
  name,
  showError = false,
  ...props
}: Omit<InputTextProps, 'onChange' | 'value'> & {
  name: string;
  default?: string;
  /**
   * Show this field's own validation message under it. Not gated on
   * "touched": the submit button stays disabled while the form is invalid,
   * so a saved profile that is already wrong must say why on load.
   */
  showError?: boolean;
}) {
  const [prefixed, value, setValue, error] = useZodFormFieldSingle(name);

  useEffect(() => {
    if (props.default && !value) {
      setValue(props.default);
    }
  }, []);

  const input = (
    <InputText {...props} name={prefixed} value={value ?? ''} onChange={(value) => setValue(value || '')} />
  );

  if (!showError || !error) {
    return input;
  }

  return (
    <>
      {input}
      <p className="mt-2 text-xs text-red-700" role="alert">
        {error}
      </p>
    </>
  );
}
